export const getSuggestionPackageId = (
  numberOfAdults: number,
  numberOfChildrens: number,
  watchList: Record<string, boolean>
) => {
  const islensktSportId = ['check-islenskt-sport'];
  const erlentSportId = ['check-meistaradeildin', 'check-pila', 'check-formulan', 'check-nfl'];
  const skemmtunIds = [
    'check-islenskt',
    'check-thaettir',
    'check-biomyndir',
    'check-barnaefni',
    'check-frettir',
    'check-idol',
    'check-fraedsla',
  ];

  const hasIslenktSport = islensktSportId.some((id) => watchList[id] === true);
  const hasErlentSport = erlentSportId.some((id) => watchList[id] === true);
  const hasSkemmtun = skemmtunIds.some((id) => watchList[id] === true);

  if (numberOfAdults >= 2 && numberOfChildrens >= 1 && hasSkemmtun && hasIslenktSport && hasErlentSport) {
    return 'pakki-allt-i-voda';
  } else if (numberOfAdults >= 2 && numberOfChildrens >= 1 && hasSkemmtun && !hasIslenktSport && hasErlentSport) {
    return 'pakki-net-skemmtun-og-erlent-sport';
  } else if (numberOfAdults >= 2 && numberOfChildrens >= 1 && hasSkemmtun && hasIslenktSport && !hasErlentSport) {
    return 'pakki-net-skemmtun-og-islenskt-sport';
  } else if (numberOfAdults >= 2 && numberOfChildrens >= 1 && hasSkemmtun && !hasIslenktSport && !hasErlentSport) {
    return 'pakki-fjolskyldupakkinn';
  } else if (numberOfAdults >= 2 && numberOfChildrens >= 1 && !hasSkemmtun && !hasIslenktSport && !hasErlentSport) {
    return 'pakki-net-og-simi';
  } else if (hasSkemmtun && !hasIslenktSport && !hasErlentSport) {
    return 'pakki-net-og-skemmtun';
  } else if (!hasSkemmtun && !hasIslenktSport && !hasErlentSport) {
    return 'pakki-net-og-simi';
  } else if (hasIslenktSport && hasErlentSport) {
    return 'pakki-net-skemmtun-og-allt-sport';
  } else if (!hasIslenktSport && hasErlentSport) {
    return 'pakki-net-skemmtun-og-erlent-sport';
  } else if (hasIslenktSport && !hasErlentSport) {
    return 'pakki-net-skemmtun-og-islenskt-sport';
  }
  return 'pakki-allt-i-voda';
};
